export const baseImageUrl = 'https://i.pravatar.cc/48?u=';
